import type { AddressGuest } from '@/modules/cart/domain/AddressGuest';
import type { Cart } from '@/modules/cart/domain/Cart';
import type { CartRepository } from '@/modules/cart/domain/CartRepository';

const saveShippingAddressForGuest = async (
  repository: CartRepository,
  addressPayload: AddressGuest | Omit<AddressGuest, 'id'>
): Promise<Cart> => {
  return repository.saveShippingAddressForGuest(addressPayload).then((cart) => {
    if (!cart) {
      throw new Error('No se pudo guardar el usuario');
    }
    return cart;
  });
};

export default saveShippingAddressForGuest;
